import { render, staticRenderFns } from "./uploadImg.vue?vue&type=template&id=d84394f6&"
import script from "./uploadImg.vue?vue&type=script&lang=js&"
export * from "./uploadImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports